import { memo, useEffect, useMemo, useState, type SyntheticEvent } from 'react';

import { getTokenIconCandidates } from '../../../utils/token-icon-sources';

export interface CryptoIconProps {
  symbol: string;
  size?: number;
  className?: string;
}

const CryptoIconComponent = ({ symbol, size = 24, className }: CryptoIconProps) => {
  const trimmedSymbol = symbol.trim();
  const iconCandidates = useMemo(() => getTokenIconCandidates(symbol), [symbol]);
  const [currentCandidateIndex, setCurrentCandidateIndex] = useState(0);

  useEffect(() => {
    setCurrentCandidateIndex(0);
  }, [iconCandidates]);

  const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
    const image = event.currentTarget;

    setCurrentCandidateIndex((currentIndex) => {
      if (currentIndex >= iconCandidates.length - 1) {
        image.onerror = null;

        return currentIndex;
      }

      return currentIndex + 1;
    });
  };

  return (
    <img
      src={iconCandidates[currentCandidateIndex]}
      alt={trimmedSymbol || 'crypto'}
      width={size}
      height={size}
      className={className}
      loading="lazy"
      onError={handleImageError}
    />
  );
};

const CryptoIcon = memo(CryptoIconComponent);

CryptoIcon.displayName = 'CryptoIcon';

export default CryptoIcon;
